import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { marketAnalysisAPI } from "../service/AuthService";
import moment from "moment/moment";
import { groupBy } from "lodash";
import Loader from "../components/Loader";

export default function MyProfitLoss() {
  const [marketAnalysis, setMarketAnalysis] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const routeMapCasino = {
    UNI_POINT_TEEN_PATTI: "generic/UNI_POINT_TEEN_PATTI",
    UNI_JOKER_TEEN_PATTI: "generic/UNI_JOKER_TEEN_PATTI",
    UNI_MUFLIS_TEEN_PATTI: "UNI_MUFLIS_TEEN_PATTI",
    UNI_1DAY_TEEN_PATTI: "UNI_1DAY_TEEN_PATTI",
    UNI_DTL_TEENPATTI: "generic/UNI_DTL_TEENPATTI",
    UNI_20_20_TEENPATTI: "distributed/back/generic/UNI_20_20_TEENPATTI",
    UNI_20_20_POKER_A: "poker/generic/UNI_20_20_POKER_A",
    UNI_20_20_POKER_B: "generic/UNI_20_20_POKER_B",
    UNI_29_CARD_BACCARAT: "poker/generic/UNI_29_CARD_BACCARAT",
    UNI_BACCARAT_A: "baccarat/generic/UNI_BACCARAT_A",
    UNI_BACCARAT: "baccarat/generic/UNI_BACCARAT",
    UNI_BACCARAT_C: "baccarat/generic/UNI_BACCARAT_C",
    UNI_DRAGON_TIGER: "generic/UNI_DRAGON_TIGER",
    UNI_20_20_DRAGON_TIGER: "distributed/back/generic/UNI_20_20_DRAGON_TIGER",
    UNI_FAST_DRAGON_TIGER: "fas/UNI_FAST_DRAGON_TIGER",
    UNI_1_DAY_DRAGON_TIGER: "UNI_1_DAY_DRAGON_TIGER",
    UNI_DTL_A: "dtl/UNI_DTL_A",
    UNI_32_CARDS_B: "generic/UNI_32_CARDS_B",
    UNI_32_CARDS_A: "generic/UNI_32_CARDS_A",
    UNI_ANDAR_BAHAR_A: "ab/UNI_ANDAR_BAHAR_A",
    UNI_ANDAR_BAHAR_C: "ab/UNI_ANDAR_BAHAR_C",
    UNI_LUCKY_7_A: "distributed/back/generic/UNI_LUCKY_7_A",
    UNI_FAST_LUCKY_7: "fas/UNI_FAST_LUCKY_7",
    UNI_LUCKY_7_B: "generic/UNI_LUCKY_7_B",
    UNI_3_CARD_JUDGMENT_A: "UNI_3_CARD_JUDGMENT_A",
    UNI_CASINO_WAR: "UNI_CASINO_WAR",
    UNI_INA_MINA_DIKA: "aaa/UNI_INA_MINA_DIKA",
    UNI_AMAR_AKBAR_ANTHONY: "aaa/UNI_AMAR_AKBAR_ANTHONY",
    UNI_20_20_CARD_RACE: "generic/UNI_20_20_CARD_RACE",
    UNI_1_CARD_METER: "distributed/back/generic/UNI_1_CARD_METER",
    UNI_1_CARD_20_20: "baccarat/generic/UNI_1_CARD_20_20",
    BOLLYWOOD_CASINO: "bollywoodCasino",
  };
  const getMarketAnalysis = async () => {
    const { response } = await marketAnalysisAPI();
    let data = response;
    //group by sport key
    let groupedData = data.reduce((r, a) => {
      r[a.sport] = r[a.sport] || [];
      r[a.sport].push(a);
      return r;
    });

    setMarketAnalysis(groupBy(data, "sport"));
    if (!response) {
      dispatch({
        type: "accountData/logOut",
        payload: {},
      });
      window.localStorage.clear();
      window.location.href = "/";
    }
  };
  useEffect(() => {
    setLoading(true);
    getMarketAnalysis();
    setLoading(false);
  }, []);
  return (
    <app-market-analysis _nghost-ng-c1381140131="" className="ng-star-inserted">
      {loading && <Loader />}
      <div _ngcontent-ng-c1381140131="" className="detail-row">
        <div _ngcontent-ng-c1381140131="" className="listing-grid">
          {Object.keys(marketAnalysis).length > 0 &&
            Object.keys(marketAnalysis).map((key) => (
              <div
                _ngcontent-ng-c1381140131=""
                className="table-responsive data-table mt-3 ng-star-inserted"
                style={{ overflow: "hidden" }}
              >
                <div _ngcontent-ng-c1381140131="" className="game-heading">
                  <span
                    _ngcontent-ng-c1381140131=""
                    className="card-header-title"
                  >
                    {key}
                  </span>
                </div>
                <table
                  _ngcontent-ng-c1381140131=""
                  id="example"
                  className="table table-striped table-bordered"
                >
                  <tbody _ngcontent-ng-c1381140131="">
                    {marketAnalysis[key]?.map((item) => (
                      <tr
                        _ngcontent-ng-c1381140131=""
                        className="ng-star-inserted"
                      >
                        <td _ngcontent-ng-c1381140131="">
                          <strong _ngcontent-ng-c1381140131="">
                            <a
                              _ngcontent-ng-c1381140131=""
                              className="marketLink"
                              href={`/market-details/${
                                key == "CASINO" ? key?.toLowerCase() : key
                              }/${
                                key == "CASINO"
                                  ? routeMapCasino[item?.eventName]
                                  : item?.eventId
                              }`}
                            >
                              {item?.eventName}
                            </a>
                          </strong>
                        </td>
                        <td _ngcontent-ng-c1381140131="" className="text-end">
                          <span
                            _ngcontent-ng-c1381140131=""
                            style={{ float: "right", fontWeight: "bold" }}
                          >
                            {" "}
                            Total Bets {item?.totalBets}{" "}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
        </div>
      </div>
    </app-market-analysis>
  );
}
